// extracted by mini-css-extract-plugin
module.exports = {"notice":"suggested-price-notice_notice__kMjNA","iconError":"suggested-price-notice_iconError__8X6s5","iconInfo":"suggested-price-notice_iconInfo__9HouK"};